module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAB9JREFUKBVj3LRp038GEgATCWoHq1LGUU8TETUkxzQAWNoJSTNVCpkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/style/img/page.png
// module id = 1278
// module chunks = 0